export interface IconProps {
  color?: string;
  size?: number;
}

export const BinIcon = ({ color = "#313131", size = 15 }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 15 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4489 1H10.9489L9.94885 0H4.94885L3.94885 1H0.448853V3H14.4489M1.44885 16C1.44885 16.5304 1.65957 17.0391 2.03464 17.4142C2.40971 17.7893 2.91842 18 3.44885 18H11.4489C11.9793 18 12.488 17.7893 12.8631 17.4142C13.2381 17.0391 13.4489 16.5304 13.4489 16V4H1.44885V16Z"
        fill={color}
      />
    </svg>
  );
};

export const PenIcon = ({ color = "#313131", size = 22 }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 19V14.5139L16.1333 0.606945C16.3778 0.413426 16.6479 0.263889 16.9437 0.158333C17.2394 0.0527779 17.5499 0 17.875 0C18.2001 0 18.5158 0.0527779 18.8222 0.158333C19.1286 0.263889 19.3934 0.422222 19.6167 0.633333L21.2972 2.11111C21.5417 2.30463 21.7201 2.53333 21.8325 2.79722C21.945 3.06111 22.0008 3.325 22 3.58889C22 3.87037 21.9442 4.13883 21.8325 4.39428C21.7209 4.64972 21.5425 4.88265 21.2972 5.09306L5.19444 19H0ZM17.8444 5.06667L19.5555 3.58889L17.8444 2.11111L16.1333 3.58889L17.8444 5.06667Z"
        fill={color}
      />
    </svg>
  );
};

export interface IconProps {
  size?: number;
  color?: string;
}
export const Lamp = ({ size = 25, color = "#878686" }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.1819 33C19.6631 33 19.2285 32.824 18.8781 32.472C18.5278 32.12 18.352 31.6849 18.3508 31.1666C18.3495 30.6484 18.5253 30.2133 18.8781 29.8613C19.2309 29.5093 19.6655 29.3333 20.1819 29.3333H31.1688C31.6877 29.3333 32.1229 29.5093 32.4745 29.8613C32.826 30.2133 33.0012 30.6484 33 31.1666C32.9988 31.6849 32.823 32.1206 32.4726 32.4738C32.1223 32.827 31.6877 33.0024 31.1688 33H20.1819ZM4.6629 11H11.0262V3.66666H7.86742L4.6629 11ZM25.6754 27.5C25.1566 27.5 24.722 27.324 24.3716 26.972C24.0212 26.62 23.8454 26.1849 23.8442 25.6666V9.16666C23.8442 8.64722 23.6684 8.21211 23.3169 7.86133C22.9653 7.51055 22.5307 7.33455 22.0131 7.33333H14.6885V12.8333C14.6885 13.3528 14.5127 13.7885 14.1611 14.1405C13.8095 14.4925 13.3749 14.6679 12.8573 14.6667H1.87039C1.19897 14.6667 0.680143 14.3917 0.313912 13.8417C-0.0523186 13.2917 -0.0980975 12.7111 0.176575 12.1L4.52556 2.2C4.83076 1.52778 5.28061 0.993055 5.87512 0.595833C6.46964 0.198611 7.13374 0 7.86742 0H11.0262C12.0333 0 12.8958 0.359333 13.6136 1.078C14.3314 1.79667 14.6897 2.65955 14.6885 3.66666H22.0131C23.539 3.66666 24.8361 4.20139 25.9043 5.27083C26.9724 6.34027 27.5065 7.63888 27.5065 9.16666V25.6666C27.5065 26.1861 27.3307 26.6218 26.9792 26.9738C26.6276 27.3258 26.193 27.5012 25.6754 27.5Z"
        fill={color}
      />
    </svg>
  );
};

export const Plug = ({ size = 25, color = "#878686" }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.3585 8.44131C28.4528 9.53052 28.4528 11.3005 27.3585 12.2535L23.5283 16.0657L12.8585 5.44601L16.6887 1.6338C17.783 0.544601 19.5613 0.544601 20.5189 1.6338L22.9811 4.08451L27.0849 0L29 1.9061L24.8962 5.99061L27.3585 8.44131ZM19.4245 16.338L17.5094 14.4319L13.6792 18.2441L10.8066 15.385L14.6368 11.5728L12.7217 9.66667L8.89151 13.4789L6.83962 11.5728L3.00943 15.385C1.91509 16.4742 1.91509 18.2441 3.00943 19.1972L5.4717 21.6479L0 27.0939L1.91509 29L7.38679 23.554L9.84906 26.0047C10.9434 27.0939 12.7217 27.0939 13.6792 26.0047L17.5094 22.1925L15.5943 20.2864L19.4245 16.338Z"
        fill={color}
      />
    </svg>
  );
};

export const ElectricPole = ({ size = 25, color = "#878686" }: IconProps) => {
  return (
    <svg
      width={size}
      height={size + 2}
      viewBox="0 0 35 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 2V35M2 6.95H33M3.55 3.65V6.95M9.75 3.65V6.95M25.25 3.65V6.95M31.45 3.65V6.95M28.35 6.95L17.5 18.5L6.65 6.95"
        stroke={color}
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const Human = ({ size = 25, color = "#878686" }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 23 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5 11.5C14.6756 11.5 17.25 8.92564 17.25 5.75C17.25 2.57436 14.6756 0 11.5 0C8.32436 0 5.75 2.57436 5.75 5.75C5.75 8.92564 8.32436 11.5 11.5 11.5Z"
        fill={color}
      />
      <path
        d="M23 22.2812C23 25.8534 23 28.75 11.5 28.75C0 28.75 0 25.8534 0 22.2812C0 18.7091 5.14912 15.8125 11.5 15.8125C17.8509 15.8125 23 18.7091 23 22.2812Z"
        fill={color}
      />
    </svg>
  );
};

export const DoubleWayArrow = ({ size = 25, color = "#878686" }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.646447 3.64645C0.451184 3.84171 0.451184 4.15829 0.646447 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646447 3.64645ZM16.3536 4.35355C16.5488 4.15829 16.5488 3.84171 16.3536 3.64645L13.1716 0.464466C12.9763 0.269204 12.6597 0.269204 12.4645 0.464466C12.2692 0.659728 12.2692 0.976311 12.4645 1.17157L15.2929 4L12.4645 6.82843C12.2692 7.02369 12.2692 7.34027 12.4645 7.53553C12.6597 7.7308 12.9763 7.7308 13.1716 7.53553L16.3536 4.35355ZM1 4.5H16V3.5H1V4.5Z"
        fill={color}
      />
    </svg>
  );
};

export const GearIcon = ({ size = 25, color = "#878686" }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 15.5A3.5 3.5 0 0 1 8.5 12A3.5 3.5 0 0 1 12 8.5a3.5 3.5 0 0 1 3.5 3.5a3.5 3.5 0 0 1-3.5 3.5m7.43-2.53c.04-.32.07-.64.07-.97c0-.33-.03-.66-.07-1l2.11-1.63c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.31-.61-.22l-2.49 1c-.52-.39-1.06-.73-1.69-.98l-.37-2.65A.506.506 0 0 0 14 2h-4c-.25 0-.46.18-.5.42l-.37 2.65c-.63.25-1.17.59-1.69.98l-2.49-1c-.22-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64L4.57 11c-.04.34-.07.67-.07 1c0 .33.03.65.07.97l-2.11 1.66c-.19.15-.25.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1.01c.52.4 1.06.74 1.69.99l.37 2.65c.04.24.25.42.5.42h4c.25 0 .46-.18.5-.42l.37-2.65c.63-.26 1.17-.59 1.69-.99l2.49 1.01c.22.08.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.66Z"
        fill={color}
      />
    </svg>
  );
};

export type iconNames =
  | "lamp"
  | "plug"
  | "electricPole"
  | "humane"
  | "bin"
  | "pen"
  | "doubleWayArrow"
  | "gear";
export const getIcon = (
  iconName?: iconNames,
  props?: IconProps
): JSX.Element => {
  if (!iconName) return <></>;
  switch (iconName) {
    case "lamp":
      return <Lamp {...props} />;
    case "plug":
      return <Plug {...props} />;
    case "electricPole":
      return <ElectricPole {...props} />;
    case "humane":
      return <Human {...props} />;
    case "bin":
      return <BinIcon {...props} />;
    case "pen":
      return <PenIcon {...props} />;
    case "doubleWayArrow":
      return <DoubleWayArrow {...props} />;
    case "gear":
      return <GearIcon {...props} />;
    default:
      return <Lamp {...props} />;
  }
};
